// extracted by mini-css-extract-plugin
export default {"PickerList":"discovery-suggestions-module__PickerList--brR81","isOpen":"discovery-suggestions-module__isOpen--o4Ntv"};